export default __webpack_public_path__ + "media/images/paw-print-254f322a40a3c9c25e1eb848a9b27d0b.svg";